module.exports = __webpack_public_path__ + "static/media/blob_top_mobile.28182866.png";